import { Button, Flex, Space } from "antd";
import FormattedMessage from "components/common/FormattedMessage";
import { Kwd } from "../Review.types";

interface ReviewKeywordsSelectProps {
    selectedKeywords: Kwd[];
    allKeywords: Kwd[];
    isLoading: boolean;
    onGenerate: () => void;
    onBack: () => void;
    onKeywordToggle: (keyword: Kwd) => void;
    hideActions?: boolean;
}

const Keyword = ({
    keyword,
    isSelected,
    onToggle
}: {
    keyword: Kwd;
    isSelected: boolean;
    onToggle: () => void;
}) => (
    <Button onClick={onToggle} type={isSelected ? "primary" : "default"}>
        {keyword}
    </Button>
);

const ReviewKeywordsSelect = ({
    selectedKeywords,
    allKeywords,
    isLoading,
    onGenerate,
    onBack,
    onKeywordToggle,
    hideActions = false
}: ReviewKeywordsSelectProps) => {
    return (
        <Flex vertical align="center" justify="center" gap="large" style={{ padding: "var(--ant-padding-sm)" }}>
            <Space direction="vertical" size={"small"} style={{ width: "100%", textAlign: "center" }}>
                <p>
                    <FormattedMessage
                        id="standalone.reviews.generator.keywords.description"
                        defaultMessage="Select keywords that best describe your experience with the product or service."
                    />
                </p>
                <p>
                    <FormattedMessage
                        id="standalone.reviews.generator.recommendedNumberOfKeywords"
                        defaultMessage="For best results consider selecting 2 or 3 keywords" />
                </p>
            </Space>
            <div style={{ display: 'flex', flexDirection: "column", gap: '10px' }}>
                {(allKeywords || []).map(keyword => (
                    <Keyword
                        key={keyword}
                        keyword={keyword}
                        isSelected={selectedKeywords.findIndex(k => k === keyword) !== -1}
                        onToggle={() => onKeywordToggle(keyword)}
                    />
                ))}
            </div>
            {!hideActions && (
                <Flex align="stretch" gap="small">
                    <Button onClick={onBack}>
                        <FormattedMessage id="standalone.common.back" defaultMessage="Back" />
                    </Button>
                    {selectedKeywords?.length > 0 && (
                        <Button
                            type="primary"
                            loading={isLoading}
                            onClick={onGenerate}
                        >
                            <FormattedMessage
                                id="standalone.reviews.generator.generate"
                                defaultMessage="Generate" />
                        </Button>
                    )}
                </Flex>
            )}
        </Flex>
    );
};

export default ReviewKeywordsSelect; 